// 戦闘判定：プレイヤー剣の当たり判定と、敵への反映
import Phaser from 'phaser';
import { Enemy } from '../entities/Enemy';
import { getAttackHitbox, Player } from '../entities/Player';
import { DIR_VECTORS } from '../data/Directions';
import { bus } from '../systems/EventBus';

const PLAYER_SWORD_DAMAGE = 1;
const ENEMY_KNOCKBACK_VEL = 180;

export class CombatSystem {
  private scene: Phaser.Scene;
  private player: Player;
  private enemies: Phaser.Physics.Arcade.Group;
  private alreadyHitInThisSwing = new Set<Enemy>();
  private lastAttacking = false;

  constructor(scene: Phaser.Scene, player: Player, enemies: Phaser.Physics.Arcade.Group) {
    this.scene = scene;
    this.player = player;
    this.enemies = enemies;
  }

  update(_delta: number): void {
    // 攻撃開始ターンを検出してヒット集合をリセット
    if (this.player.isAttacking && !this.lastAttacking) {
      this.alreadyHitInThisSwing.clear();
    }
    this.lastAttacking = this.player.isAttacking;
    if (!this.player.isAttacking) return;

    const hitbox = getAttackHitbox(this.player);
    const dir = DIR_VECTORS[this.player.facing];
    const kbX = dir.x * ENEMY_KNOCKBACK_VEL;
    const kbY = dir.y * ENEMY_KNOCKBACK_VEL;

    this.enemies.getChildren().forEach((go) => {
      const e = go as Enemy;
      if (!e.active) return;
      if (this.alreadyHitInThisSwing.has(e)) return;
      const r = e.getBounds();
      if (Phaser.Geom.Intersects.RectangleToRectangle(hitbox, r)) {
        this.alreadyHitInThisSwing.add(e);
        const killed = e.damage(PLAYER_SWORD_DAMAGE, kbX, kbY);
        if (killed) {
          bus.emit('enemy-killed', { x: e.x, y: e.y });
        }
        // ヒットエフェクト：画面シェイク弱め＋トーンフラッシュ
        this.scene.cameras.main.shake(60, 0.002);
      }
    });
  }
}
